// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
export type MemberListFragmentFragment = {
  __typename?: "Organization";
  id: string;
  permittedToInviteMembers: boolean;
  samlIntegration?: {
    __typename?: "SamlIntegration";
    id: string;
    idpEntityId: string;
  } | null;
  memberships: Array<{
    __typename?: "OrganizationMembership";
    id: string;
    createdAt: number;
    email: string;
    samlUid?: string | null;
    accepted: boolean;
    expired: boolean;
    user?: {
      __typename?: "User";
      id: string;
      avatarUrl?: string | null;
      fullname?: string | null;
    } | null;
    permissions?: Array<{
      __typename?: "OrganizationPermission";
      id: string;
      restricted: boolean;
      view: boolean;
      modify: boolean;
      billing: boolean;
      api: boolean;
      manage: boolean;
      createWorkbooks: boolean;
    } | null> | null;
  }>;
};

export const MemberListFragmentFragmentDoc = gql`
  fragment MemberListFragment on Organization {
    id
    permittedToInviteMembers
    samlIntegration {
      id
      idpEntityId
    }
    memberships {
      id
      createdAt
      email
      samlUid
      accepted
      expired
      user {
        id
        avatarUrl
        fullname
      }
      permissions {
        id
        restricted
        view
        modify
        billing
        api
        manage
        createWorkbooks
      }
    }
  }
`;
